/**
 * Route for `custom-report-columns`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomReportColumnsPage } from "../features/custom-report-columns/CustomReportColumnsPage";

export const customReportColumnsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-report-columns",
	component: CustomReportColumnsPage,
});

export default customReportColumnsRoute;
